import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Simple animated loader for app initialization
 * Shows during language system loading - no text to avoid translation issues
 */
import React from 'react';
const InitLoader = () => {
    return (_jsxs("div", Object.assign({ style: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: '#ffffff',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
        } }, { children: [_jsx("div", { style: {
                    width: '60px',
                    height: '60px',
                    border: '6px solid #f3f3f3',
                    borderTop: '6px solid #007acc',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                } }), _jsx("style", { children: `
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      ` })] })));
};
export default InitLoader;
